import { _, removeClasses } from '../utils.js'

class Menu {
    constructor() {
        this.body = _('body', 'element').node()
        this.html = _('html', 'element').node()
        this.menu = _('menu').node()
        this.page = _('page', 'element').node()
        this.menuItem = _('menu-item', 'element').nodes()
        this.menuUnfocus = _('menu-unfocus', 'element').nodes()
        this.menuLink = _('menu-link', 'element').nodes()
        this.subTrigger = _('sub-trigger', 'element').nodes()
        this.backTrigger = _('back-trigger', 'element').nodes()
        this.menuList = _('menu-list', 'element').nodes()
        this.menuSub = _('menu-sub', 'element').nodes()
        this.timer
        this.classes = {
            menuItemActive: 'menu__item--active',
            pageActive: 'page--overlay',
            menuSubActive: 'menu__sub--open',
        }
        this.menuLink.map((el) => {
            el.addEventListener('focus', this.addAccessibilityActiveClass)
        })
        this.menuUnfocus.map((el) => {
            el.addEventListener('focus', this.removeAccessibilityActiveClass)
        })
        this.menuList.map((el) => {
            el.addEventListener('mouseenter', this.bgToggleClass)
            el.addEventListener('mouseleave', this.bgToggleClass)
        })
        this.subTrigger.map((el) => {
            el.addEventListener('click', this.openSubmenu)
        })
        this.backTrigger.map((el) => {
            el.addEventListener('click', this.closeSubmenu)
        })
    }

    openSubmenu = (e) => {
        e.currentTarget
            .closest(_('menu-item', 'element').str())
            .querySelector(_('menu-sub', 'element').str())
            .classList.add(this.classes.menuSubActive)
    }

    closeSubmenu = (e) => {
        e.currentTarget
            .closest(_('menu-item', 'element').str())
            .querySelector(_('menu-sub', 'element').str())
            .classList.remove(this.classes.menuSubActive)
    }

    addAccessibilityActiveClass = (e) => {
        removeClasses(this.menuItem, this.classes.menuItemActive)
        e.currentTarget
            .closest(_('menu-item', 'element').str())
            .classList.add(this.classes.menuItemActive)

        this.page.classList.add(this.classes.pageActive)
    }

    removeAccessibilityActiveClass = () => {
        removeClasses(this.menuItem, this.classes.menuItemActive)
        this.page.classList.remove(this.classes.pageActive)
    }

    bgToggleClass = (e) => {
        if (e.type === 'mouseenter') {
            this.timer = setTimeout(this.bgAddClass, 500)
        } else {
            clearTimeout(this.timer)
            removeClasses(this.menuItem, this.classes.menuItemActive)
            this.page.classList.remove(this.classes.pageActive)
        }
    }

    bgAddClass = () => {
        this.page.classList.add(this.classes.pageActive)
    }
}

export default Menu
